export default {
  translation: {
    common: {
      emailOrUsername: 'E-Mail-Adresse oder Benutzername',
      invalidEmailOrUsername: 'Ungültige E-Mail-Adresse oder Benutzername',
      invalidPassword: 'Ungültiges Passwort',
      noInternetConnection: 'Keine Internetverbindung',
      pageNotFound_title: 'Seite nicht gefunden',
      password: 'Passwort',
      projectManagement: 'Projekt-Management',
      serverConnectionFailed: 'Serververbindung fehlgeschlagen',
      unknownError: 'Unbekannter Fehler, bitte später erneut versuchen',
    },

    action: {
      logIn: 'Einloggen',
    },
  },
};
